export default __webpack_public_path__ + "static/media/chatify.9373edda.png";